import { render, staticRenderFns } from "./TherapyAndLifeCoaching.vue?vue&type=template&id=2d12354a"
import script from "./TherapyAndLifeCoaching.vue?vue&type=script&lang=js"
export * from "./TherapyAndLifeCoaching.vue?vue&type=script&lang=js"
import style0 from "./TherapyAndLifeCoaching.vue?vue&type=style&index=0&id=2d12354a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports